import React, { useState } from 'react';
import CircleImage from "olive-react-myoneui/lib/CircleImage";
import CircleImageContent from "olive-react-myoneui/lib/CircleImageContent";
import { Link } from "react-router-dom";
import CommentsLikesBlock from "./CommentsLikesBlock";
import PostVideoComponent from "./PostVideoComponent";
import SampleImage from "../../../../assets/img/sample.png";
import SampleVideo from "../../../../assets/img/google_ai_course.mp4";
import SamplePDF from "../../../../assets/img/pdf-sample.pdf";
import { leftArrow, rightArrow } from "../../../constants/icons";
import PostDocument from "./PostDocument";
import PostImageComponent from "./PostImageComponent";
import { convertISOToReadable } from '../../../../helpers/datetime_helper';

const Post = ({
  userProfle,
  newsFeedLunchUrl,
  newsFeedApiUrl,
  postId,
  className,
  postLogo,
  postTitle,
  postMetaDesc,
  postedTime,
  postDesc,
  postDescCount,
  postLikedByUser,
  postComments,
  postTotalComments,
  postTotalLikes,
  postImage,
  postedComment,
  postRef }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleDescription = () => {
    setIsExpanded(!isExpanded);
  };

  const maxChars = 148;
  const displayDesc = isExpanded ? postDesc : postDescCount > maxChars ? `${postDesc.substring(0, maxChars)}...` : postDesc;

  const postImageData = postImage
                        ?.filter(item => item.imageUrl !== null)
                        .map(item => ({ postImage: item.imageThumbnailUrl }));

  const postVideosData = postImage
                          ?.filter(item => item.videoUrl !== null)
                          .map(item => ({ 
                            postVideoTitle: item.name,
                            postVideoThumbnail: item.videoThumbnailUrl,
                            postVideo: item.videoUrl 
                          }));

  const postDocumentsData = postImage
                              ?.filter(item => item.attachmentUrl !== null)
                              .map(item => ({
                                className: "",
                                fileType: item.name.substring(item.name.lastIndexOf(".") + 1),
                                docFileName: item.attachmentUrl,
                                docName: item.name,
                                docUploadDate: item.createdAt ? convertISOToReadable(item.createdAt, 'short', false) : ''
                              }))

  return (
    <div
      className={`${className || ""} information-block bg-information-white myk__stu-info-block`}
    >
      <div className="information-wrap mb-2">
        <div className="information-holder align-items-start gap-2">
          {postLogo && (
            <CircleImage className="circle-wrap circle-wrap-md">
              {postLogo === 'two' ? (<CircleImageContent src={postLogo} />) : (<img src={postLogo} className="img-fluid" />)}
            </CircleImage>
          )}
          <div className="information-detail">
            <h3>{postTitle}</h3>
            <p>
              {postedTime && `${postedTime || ""} .`} {postMetaDesc}
            </p>
          </div>
        </div>
      </div>
      <div className="myk__stu-info-content" dangerouslySetInnerHTML={{__html:displayDesc.replace(/<\/?script[^>]*>/g, "")}} />
      {postDescCount > maxChars && (
      <Link to="#" onClick={toggleDescription} className="btn btn-transparent my-2 p-0">
        {isExpanded ? "Show Less" : "Read More"}
      </Link>
      )}

      {postImageData && postImageData?.length > 0 && (
        <PostImageComponent className="mt-2 mb-3" postImageData={postImageData} />
      )}
      {postVideosData && postVideosData?.length > 0 && (
        <PostVideoComponent className="mt-2 mb-3" postVideosData={postVideosData} />
      )}
      {postDocumentsData && postDocumentsData?.length > 0 && (
        <div className="myk__stu-comm-doc-wrapper">
          {postDocumentsData.map((doc, index) => (
            <PostDocument
              key={index}
              className={doc.className}
              fileType={doc.fileType}
              docFileName={doc.docFileName}
              docName={doc.docName}
              docUploadDate={doc.docUploadDate}
            />
          ))}
        </div>
      )}

      <CommentsLikesBlock
        userProfle={userProfle}
        postLikedByUser={postLikedByUser} 
        postComments={postComments} 
        postTotalComments={postTotalComments} 
        postTotalLikes={postTotalLikes}
        postId={postId}
        newsFeedLunchUrl={newsFeedLunchUrl}
        newsFeedApiUrl={newsFeedApiUrl}
        postedComment={postedComment}
      />
      <p className="lastdiv" ref={postRef}></p>
    </div>
  );
}

export default Post;
